export default "__VITE_ASSET__CUXffFN9__"